module.exports = __webpack_public_path__ + "static/img/24.cfde9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/24.png
// module id = Iylb
// module chunks = 0